import React from 'react';

import { Switch, Redirect, Route } from 'react-router-dom';

import MainNavbar from 'modules/main-navbar';
import PricingPage from 'pages/pricing';
import CostingPage from 'pages/costing';
import TenderPage from 'pages/tender';

import * as routes from 'routes';

const RouterPage = () => {
  return (
    <>
      <MainNavbar />
      <Switch>
        <Redirect path={routes.BASE_ROUTE} exact to={routes.PRICING_ROUTE} />
        <Route path={routes.PRICING_ROUTE} component={PricingPage} />
        <Route path={routes.COSTING_ROUTE} component={CostingPage} />
        <Route path={routes.TENDER_ROUTE} component={TenderPage} />
      </Switch>
    </>
  );
};

export default RouterPage;
